import React from 'react';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMDropDownButton from 'components/dashboard/form/SMDropDownButton';
import sprintf from 'sprintf';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMRestClient from 'lib/SMRestClient';
import update from 'react-addons-update';
import SMORoomListTableRow from './SMORoomListTableRow';
import SMSpaceResource from 'resources/SMSpaceResource';
import Spinner from 'components/shared/SMMaterialSpinner';

class SMORoomListView extends React.Component {

  constructor(props) {
    super(props);
    this.currentPage = 1;
    this.canRequest = true;
    this.state = {
      display: this.props.display,
      listItems: [],
      selectedRowIndex: 0
    };
  }

  componentDidMount(){
    if (this.props.display == SMConst.Display.Visible) {
      this.requestResource();
    }
    $(document).on("SMORoomListViewDidScrollBottom", this.roomListViewDidScrollBottom.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.space == nextProps.space) return null;
    let newState = {
      display: this.props.display,
      listItems: [],
      selectedRowIndex: 0
    };
    this.canRequest = true;
    this.currentPage = 1;
    if (this.props.space !== nextProps.space){
      if (nextProps.space == null) {
        newState.display = SMConst.Display.Init;
      }
    }
    if (this.props.display !== nextProps.display){
      newState.display = nextProps.display;
    }
    this.setState(newState);
  }

  componentWillUpdate(nextProps, nextState) {
    $(document).off("SMORoomListViewDidScrollBottom", this.roomListViewDidScrollBottom.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.space !== prevProps.space &&
      this.props.space != null) {
      this.currentPage = 1;
      this.requestResource();
    }
    $(document).on("SMORoomListViewDidScrollBottom", this.roomListViewDidScrollBottom.bind(this));
  }

  requestResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    if (this.state.display == SMConst.Display.Loading) return;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});

    let queries = {};
    queries["space_id"] = this.props.space.id;
    if (this.currentPage != 1) queries["page"] = this.currentPage;
      SMOwnerResource.getRooms(this.props.owner.id, queries, (responses, error, xhr)=>{
      if(error) return;
      let links = SMRestClient.getLinks(xhr),
          listItems = this.state.listItems;
      if (links["next"]) this.canRequest = true;

      this.currentPage++;
      listItems = update(listItems, {$push: responses});
      this.setState({
        display: SMConst.Display.Visible,
        listItems: listItems,
      });
    });
  }

  tableDidSelectRowAtIndex(rowIndex) {
    let room = this.state.listItems[rowIndex];
    this.setState({selectedRowIndex: rowIndex});
  }

  roomDidUpdate(rowIndex, newRoom) {
    let replace = {};
    replace[rowIndex] = {$set: newRoom};
    this.setState({listItems: update(this.state.listItems, replace)});
  }

  roomDidDelete(rowIndex) {
    this.setState({listItems: update(this.state.listItems, {$splice: [[rowIndex, 1]]})});
  }

  roomListViewDidScrollBottom(e){
    this.requestResource(true);
  }

  /* Render */

  renderInit (){
    return (
      <p className="dashboard-maincol__message">{I18n.t("dashboard.text_000013")}</p>
    );
  }

  subMenuItemDidSelectRowAtIndex(rowIndex){
    let index = (this.props.space.can_display) ? rowIndex : rowIndex + 1;
    let space = this.props.space;
    switch (index) {
      case 0:
        if (
          space.status !== SMConst.Visibility.Visible ||
          window.confirm(I18n.t("dashboard.notice_000011"))
        ) {
          let v = SMConst.Visibility,
              status = (this.props.space.status == v.Visible) ? v.Hidden : v.Visible,
              queries = {owner_id: this.props.owner.username},
              formData = new FormData();
          formData.append("status", status);
          SMSpaceResource.updateSpace(this.props.space.username, formData, queries, (newSpace)=>{
            if(this.props.delegate && typeof this.props.delegate.spaceDidUpdate === 'function'){
              this.props.delegate.spaceDidUpdate(this.props.selectedParentRowIndex, newSpace);
            }
            this.setState({space: newSpace});
          });
        }
        break;
      // case 1:
      //   if(window.confirm(I18n.t("dashboard.notice_000003"))){
      //     let newSpace = React.addons.deepCopy(this.state.space);
      //     newSpace.id = null;
      //     console.log(newSpace);
	    //   }
      //   break;
      case 1:
        if(window.confirm(I18n.t("dashboard.notice_000003"))){
          let queries = {owner_id: this.props.owner.username};
          SMSpaceResource.deleteSpace(this.props.space.username, queries, ()=>{
            if(this.props.delegate && typeof this.props.delegate.spaceDidDelete === 'function'){
              this.props.delegate.spaceDidDelete(this.props.selectedParentRowIndex);
            }
          });
	      }
        break;
    }
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  menuButtonDidSelect(e){
    this.trackPageEvent('od edit space');
  }

  renderDefault (){
    let owner = this.props.owner,
        space = this.props.space,
        rows = [];
    if (this.state.listItems.length == 0) {
      rows.push(
        <div key="0" className="room-list__box">
          <p className="message-supplement ta-c mt40 mb40">{I18n.t("dashboard.notice_000002")}</p>
        </div>
      );
    } else {
      for (let i = 0; i < this.state.listItems.length; i++) {
        let item = this.state.listItems[i];
        rows.push(
          <SMORoomListTableRow
            key={item.id}
            owner={owner}
            space={space}
            room={item}
            delegate={this}
            rowIndex={i} />
        );
      }
      if (this.canRequest) {
        rows.push(
          <p key="loading" className="js-loading-row">{I18n.t("dashboard.label_000128")}</p>
        );
      }
    }

    let subMenuItems = [];
    if (space.can_display) {
      subMenuItems.push({title: (space.status == SMConst.Visibility.Visible) ? I18n.t("dashboard.label_000079") : I18n.t("dashboard.label_000080"), link: "#"});
    }
    //subMenuItems.push({title: "コピーして新規作成", link: "#"});
    subMenuItems.push({title: I18n.t("dashboard.label_000081"), link: "#"});

    let name = SMFormatHelper.spaceName(space);

    return (
      <div>
        <SMDropDownButton
          title={I18n.t("dashboard.label_000082")}
          link={Routes.edit_owner_dashboard_space_path(owner.username, space.username)}
          subMenuItems={subMenuItems}
          delegate={this} />
        <p className="fr mr10 mt9">
          <a href={Routes.space_path(space.username)} target="_blank" className="link-hover-border">{I18n.t("dashboard.label_000083")}</a>
        </p>
        <h2 className="dashboard-title mb30 mr250">{sprintf(I18n.t("dashboard.label_000084"), name)}</h2>
        <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {rows}
        </CSSTransitionGroup>
        <a onClick={this.trackPageEvent.bind(this, 'od add room')} href={Routes.new_owner_dashboard_space_room_path(owner.username, space.username)} className="button-gray room-list__button-add"><i className="fa fa-plus"></i>{I18n.t("dashboard.label_000085")}</a>
      </div>
    );
  }
  
  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }

  render() {
    switch (this.state.display) {
      case SMConst.Display.Hidden: return <div />;
      case SMConst.Display.Init: return this.renderInit();
      case SMConst.Display.Loading: return this.renderLoading();
      default: return this.renderDefault();
    }
  }
}
SMORoomListView.defaultProps = {
  display: SMConst.Display.Init,
};
export default SMORoomListView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/SMORoomListView.jsx